















































































import dayjs from 'dayjs'
import {
  Vue, Component, Prop, Watch, Mixins,
} from 'vue-property-decorator'
import { CommentCardType } from '../../types'
import CDatePicker from '../inputs/CDatePicker.vue'
import CTimePicker from '../inputs/CTimePicker.vue'
import MainMixin from '../../mixins/MainMixin'

@Component({
  components: {
    CDatePicker,
    CTimePicker,
  },
})

export default class CommentCard extends Mixins(MainMixin) {
  @Prop() title!:string

  selectedDate = ''

  $refs:any

  checkboxes = {
    email: true,
    textClub: false,
  }
  // get managers() {
  //   return [{ text: 'Management', value: 'management' }, { text: 'Owner', value: 'owner' }, { text: 'Other', value: 'other' }].concat(this.$store.getters.allManagers)
  // }

  // get date() {
  //   const date = dayjs(this.selectedDate).hour(Number(this.selectedTime.split(':')[0])).minute(Number(this.selectedTime.split(':')[1]))
  //   return date
  // }

  ratings = [{ text: 'N/A', value: -1 }].concat([1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(n => ({ text: String(n), value: n })))


  data:CommentCardType = {
    user: '',
    date: this.justDate(new Date()),
    shift: '',
    employee: '',
    contact: {
      firstName: '', lastName: '', email: '', phone: '',
    },
    foodRating: -1,
    serviceRating: -1,
    note: '',
  }

  presubmit() {

  }

  clearForm() {
    console.log('resetting')
    this.data = {
      user: '',
      date: this.justDate(new Date()),
      shift: '',
      employee: '',
      contact: {
        firstName: '', lastName: '', email: '', phone: '',
      },
      foodRating: -1,
      serviceRating: -1,
      note: '',
    }
    this.selectedDate = ''

    const observer:any = this.$refs.obs
    const datePicker:any = this.$refs.datepicker
    datePicker.reset()
    observer.reset()
  }

  @Watch('selectedDate')
  dateChange(newDate:string) {
    this.data.date = newDate
  }

  created() {
    if (!this.$store.getters.multiUser) {
      this.data.user = this.$store.getters.uid
    }
  }
}

